import { useCallback, useEffect, useState } from "react";

const DISMISS_KEY = "nb_install_dismissed";
const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
export const isIOS = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isSafari = /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|Chrome/i.test(ua);
export const isAndroid = /Android/i.test(ua);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferredPrompt = e; window.dispatchEvent(new Event("nb-install-ready")); });
  window.addEventListener("appinstalled", () => { deferredPrompt = null; localStorage.setItem(DISMISS_KEY, "installed"); window.dispatchEvent(new Event("nb-install-ready")); });
}

export function useInstall() {
  const [canPrompt, setCanPrompt] = useState(!!deferredPrompt);
  const [standalone, setStandalone] = useState(isStandalone());
  const [dismissed, setDismissed] = useState(!!localStorage.getItem(DISMISS_KEY));

  useEffect(() => {
    const sync = () => { setCanPrompt(!!deferredPrompt); setStandalone(isStandalone()); setDismissed(!!localStorage.getItem(DISMISS_KEY)); };
    window.addEventListener("nb-install-ready", sync);
    return () => window.removeEventListener("nb-install-ready", sync);
  }, []);

  const promptInstall = useCallback(async () => {
    if (!deferredPrompt) return "unavailable";
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") deferredPrompt = null;
    setCanPrompt(!!deferredPrompt);
    return outcome;
  }, []);

  const dismiss = useCallback(() => { localStorage.setItem(DISMISS_KEY, "1"); setDismissed(true); }, []);

  const platform = isIOS ? "ios" : isAndroid ? "android" : "desktop";
  return { canPrompt, promptInstall, standalone, dismissed, dismiss, platform, isSafari };
}
